module.exports = __webpack_public_path__ + "media/Select.c731882f.ogg";